import { render, staticRenderFns } from "./theme-switch.vue?vue&type=template&id=36cc26e3"
import script from "./theme-switch.vue?vue&type=script&lang=js"
export * from "./theme-switch.vue?vue&type=script&lang=js"
import style0 from "./theme-switch.vue?vue&type=style&index=0&id=36cc26e3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports